import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    logs: []
};

export const loggerSlice = createSlice({

    name: "logs",
    initialState,

    reducers: {
        setLogs: (state, action) => {
            state.logs = action.payload;
        },
        addLogs: (state, action) => {
            state.logs.push(action.payload);

        },
        clearLogs: (state, action) => {
            state.logs = [];
        }
    },

});

export const { setLogs, addLogs, clearLogs } = loggerSlice.actions;

export const logs = (state) => state.logs;

export default loggerSlice.reducer;